import React, { useEffect, useState } from "react";
import {
  GoogleLogin,
  CredentialResponse,
  useGoogleLogin,
} from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/joy";
import "./LoginPage.css";
import AbsyzLogo from "../../assessts/images/ABSYZ_Logo_HighQuality 2.png";
import backGroundImage from "../../assessts/images/Pre-sales-login-backgroundImage1.png";
import { networkUrls } from "../../services/networkurls";
import { Post } from "../../services/apiServices";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import ReuseableSnackbar from "../../components/Snackbar/Snackbar";
import axios from "axios";
import { Box, Button, Typography } from "@mui/material";
import constants from "../../utils/constants";
import removeClientSideStorage from "../../utils/functions";
import ReusableModal from "../../components/ReusableModal/ReusableModal";
interface gmailResponseDTO {
  email: string;
  name: string;
  given_name: string;
  family_name: string;
  sub: string;
  hd: string;
}

const GoogleLoginComponent: React.FC = () => {
  const location = useLocation();
  const [isShowSnackbar, setIsShowSnackbar] = useState(false);
  const[email,setEmail]=useState("");
  const[type,setType]=useState("drive-access");
  const[openModal,setOpenModal]=useState(false);
  const [snackbarInfo, setSnackbarInfo] = useState({
    color: "",
    message: "",
  });
  const navigate = useNavigate();
  const loginAPICall = async (payload: {
    email: string;
    first_name: string;
    last_name: string;
    username: string;
    gmail_id: string;
    organization: string;
  }) => {
    try {
      const response = await Post(networkUrls.googleLogin, payload, false);
      console.log(response,"res")
      if (response?.data?.status === true) {
        const token = response?.data?.data?.access_token;
        const refreshToken = response?.data?.data?.refresh_token;
        const role = response?.data?.data?.userDetails?.is_admin;

        const currentTime = new Date().getTime();
        const expiryTime = currentTime + 24 * 60 * 60 * 1000;

        Cookies.set("expiryTime", expiryTime.toString());
        localStorage.setItem(
          "userDetails",
          JSON.stringify(response?.data?.data?.userDetails)
        );
        // setLoading(false);
        
        Cookies.set("accessToken", token);
        Cookies.set("refreshToken", refreshToken);
        Cookies.set("selectedCategory", "Industries");
        // Cookies.set("logout_key", "false")


        // if (response?.data?.data?.userDetails?.is_new_user === true) {
        //   setEmail(payload.email)
        //   setOpenModal(true);
        //   return;
         
        // }
        setIsShowSnackbar(true);
        setSnackbarInfo({
          color: "success",
          message: response?.data?.message,
        });
        setTimeout(()=>{
          navigate(
            role === true
              ? constants.navigationUrls.adminDashboard
              : constants.navigationUrls.userDashboard
          );
        },500)
       
      } else if (response?.data?.status === false) {
         setSnackbarInfo({
          color: "error",
          message: response?.data?.message,
        });
        setIsShowSnackbar(true);
      }
    } catch (error:any) {
      console.log(error,"err")
      
    }
  };


  const handleSuccess = async (gmailResponse: CredentialResponse) => {
    try {
      if (gmailResponse.credential) {
        const decoded = jwtDecode<gmailResponseDTO>(gmailResponse.credential);
        const payload = {
          email: decoded.email,
          first_name: decoded.given_name,
          last_name: decoded.family_name,
          username: decoded.name,
          gmail_id: decoded.sub,
          organization: decoded.hd,
        };
        loginAPICall(payload);
      }
    } catch (error) {
      setIsShowSnackbar(true);
      setSnackbarInfo({
        color: "error",
        message: "Failed to login. Please try again later",
      });
    }
  };
  useEffect(() => {
    if (!constants.client_side_storage.accessToken) {
      login();
    } else {
      const isAdmin = !!constants.client_side_storage.userDetails.is_admin;
      navigate(
        isAdmin
          ? constants.navigationUrls.adminDashboard
          : constants.navigationUrls.userDashboard
      );
    }
  }, []);

  const handleFailure = () => {
    console.error("Login Failed");
  };
  const login = useGoogleLogin({
    ux_mode: "popup",
    onSuccess: async (tokenResponse: any) => {
      try {
        const userDetails = await getUserDetails(tokenResponse.access_token);
        if (userDetails.data) {
          const payload = {
            email: userDetails.data.email,
            first_name: userDetails.data.given_name,
            last_name: userDetails.data.family_name,
            username: userDetails.data.name,
            gmail_id: userDetails.data.id || userDetails.data.sub || "",
            organization: userDetails.data.hd,
          };
          loginAPICall(payload);
        }
      } catch (error: any) {
        console.log("Error fetching Google user info:");
      }
    },
    onError: (error: any) => {
      console.log(error, "error in callback");
      login();
    },
  });

  const getUserDetails = async (access_token: string) => {
    const userDetails = await axios.get(
      "https://www.googleapis.com/oauth2/v1/userinfo",
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    return userDetails;
  };
  return (
    <>
      <Grid container sx={{ height: "100vh" }}>
        <Grid
          xs={12}
          md={6}
          sx={{ position: "relative", display: { xs: "none", md: "block" } }}
        >
          <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
            <img
              src={backGroundImage}
              alt="Login Background"
              style={{
                width: "100%",
                height: "120vh",
                objectFit: "cover",
              }}
            />
          </Box>
        </Grid>
        <Grid xs={12} md={6} className="right-side-form">
          <Box
            sx={{
              width: "100%",
              maxWidth: "400px",
              padding: "20px",
              borderRadius: "10px",
              display:"flex",
              justifyContent:"center",
              flexDirection:"column",
              alignItems: "center",
            }}
          >
            <img
              src={AbsyzLogo}
              alt="Absyz Logo"
              style={{ height: "50px", marginBottom: "20px" }}
            />
            <Typography
              variant="h5"
              sx={{ fontSize: "25px", mb: 1, color: "#0B2663" }}
            >
              Welcome To <strong style={{ color: "#0B2663" }}>PRE-SALES</strong>
            </Typography>
            <Typography variant="body1" sx={{ color: "#0B2663", mb: 3 }}>
              Please <strong>Sign In</strong> To Continue.
            </Typography>
            {/* <Button onClick={()=>setOpenModal(true)}>open modal</Button> */}
            <Box sx={{ mt: 2,ml:0,display:"flex",justifyContent:"center"   }}>
              <GoogleLogin
                onSuccess={handleSuccess}
                onError={handleFailure}
                useOneTap
              />
              {isShowSnackbar && (
                <ReuseableSnackbar
                  isShowSnackbar={isShowSnackbar}
                  colour={snackbarInfo.color}
                  setIsShowSnackbar={setIsShowSnackbar}
                  message={snackbarInfo.message}
                />
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
      {openModal && <div>
        <ReusableModal open={openModal} setOpen={setOpenModal} type={type} email={email}  setType={setType}   />
        
        </div>}
    </>
  );
};

export default GoogleLoginComponent;
